import {AfterViewInit, Component, ElementRef} from '@angular/core';

import SwaggerUI from 'swagger-ui';
import { ConfigService } from './core/services/config.service';
import { TokenService } from './core/auth';

@Component({
    selector: 'app-swagger',
    templateUrl: './swagger.component.html',
    styles: []
})
export class SwaggerComponent implements AfterViewInit {

    constructor(private el: ElementRef, private token: TokenService) {
    }

    ngAfterViewInit() {
        const token = this.token.getToken();

        const url = ConfigService.getApiEndpoint() + 'v1/swagger';

        // https://swagger.io/docs/open-source-tools/swagger-ui/usage/configuration/
        const ui = SwaggerUI({
            url: url,
            domNode: this.el.nativeElement.querySelector('.swagger-container'),
            deepLinking: false,
            presets: [
                SwaggerUI.presets.apis
            ],
            defaultModelsExpandDepth: 10,
            defaultModelExpandDepth: 10,
            requestInterceptor: function(request) {
                request.headers.Authorization = 'Bearer ' + token;
                return request;
            }
        });
    }
}
